
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#50585B","stroke-width":"1.1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3 3.087C3 1.934 6.068 1 9.85 1s6.848.934 6.848 2.087-3.066 2.087-6.848 2.087S3 4.24 3 3.087z"}}),_c('path',{attrs:{"d":"M16.696 3.087v3.13c0 1.153-3.065 2.088-6.848 2.088C6.066 8.305 3 7.37 3 6.218v-3.13"}}),_c('path',{attrs:{"d":"M16.696 6.218v3.13c0 1.152-3.065 2.087-6.848 2.087C6.066 11.435 3 10.5 3 9.348v-3.13m7.304 10.434c0-1.152 3.066-2.087 6.848-2.087S24 15.5 24 16.654c0 1.152-3.066 2.086-6.848 2.086s-6.848-.934-6.848-2.087z"}}),_c('path',{attrs:{"d":"M24 16.653v3.13c0 1.152-3.065 2.087-6.848 2.087-3.782 0-6.848-.935-6.848-2.087v-3.13"}}),_c('path',{attrs:{"d":"M24 19.783v3.13C24 24.065 20.935 25 17.152 25c-3.782 0-6.848-.935-6.848-2.087v-3.13m6.392-10.435v3.13m0 0c0 1.152-3.065 2.087-6.848 2.087C6.066 14.565 3 13.63 3 12.478v-3.13m13.696 3.13v2.087"}}),_c('path',{attrs:{"d":"M3 12.479v3.13c0 1.152 3.066 2.087 6.848 2.087h.457"}}),_c('path',{attrs:{"d":"M3 15.61v3.13c0 1.152 3.066 2.087 6.848 2.087h.457"}})])])
          )
        }
      }
    